// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getFirstName } from '../../../../user/userUtil';

// Styles
import './LiveCursorNameTag.scss';

const LiveCursorNameTag = (props) => {
    const { user } = props;

    const firstName = getFirstName(user);

    return (
        <div className="LiveCursorNameTag">
            <span>{firstName}</span>
        </div>
    );
};

LiveCursorNameTag.propTypes = {
    user: PropTypes.object,
};

export default LiveCursorNameTag;
